import { Translate } from 'react-redux-i18n'
import TooltipExpression from '../../../common/tooltipExpression'

export const RATIO_CODE = {
  AVERAGE_COST: 'FA149',
  CREDIT_COST: 'RT0239',
  LOAN_YIELD: 'FA061',
  ALLOWANCE_EXPENSES: 'FA169',
}

export const TREND_LEFT_DATA = [
  {
    value: RATIO_CODE.AVERAGE_COST,
    color: '#B5D5F2',
    width: 'calc(100% - 3px)',
    dotColor: '#72A1CB',
    disableFill: false,
    tooltipContent: (
      <TooltipExpression
        expressions={[
          {
            text: <Translate value="financialAnalysis.AVERAGE_COST_1" />,
            operator: '=',
          },
          {
            text: <Translate value="financialAnalysis.AVERAGE_COST_2" />,
            isDivide: true,
            textUnder: <Translate value="financialAnalysis.AVERAGE_COST_3" />,
          },
        ]}
      />
    ),
  },
  {
    value: RATIO_CODE.CREDIT_COST,
    color: '#C4D886',
    width: 'calc(50% - 3px)',
    dotColor: '#83A04C',
    disableFill: false,
    tooltipContent: (
      <TooltipExpression
        expressions={[
          {
            text: <Translate value="financialAnalysis.CREDIT_COST_1" />,
            operator: '=',
          },
          {
            text: (
              <>
                (-1) * <Translate value="financialAnalysis.CREDIT_COST_2" />
              </>
            ),
            isDivide: true,
            textUnder: <Translate value="financialAnalysis.CREDIT_COST_3" />,
          },
        ]}
      />
    ),
  },
  {
    value: RATIO_CODE.LOAN_YIELD,
    color: '#F49966',
    width: 'calc(50% - 3px)',
    dotColor: '#F49966',
    disableFill: true,
    tooltipContent: (
      <TooltipExpression
        expressions={[
          {
            text: <Translate value="financialAnalysis.LOAN_YEILD_1" />,
            operator: '=',
          },
          {
            text: <Translate value="financialAnalysis.LOAN_YEILD_2" />,
            isDivide: true,
            textUnder: <Translate value="financialAnalysis.LOAN_YEILD_3" />,
          },
        ]}
      />
    ),
  },
]
